import { ORDERS_PAGE_SIZE } from "common/constants";

export const ORDERS_ME_REQUESTED = "ORDERS_ME_REQUESTED";
export const ORDERS_ME_RECEIVED = "ORDERS_ME_RECEIVED";
export const ORDERS_ME_REQUEST_FAILED = "ORDERS_ME_REQUEST_FAILED";
export const ORDER_BY_CODE_REQUESTED = "ORDER_BY_CODE_REQUESTED";
export const ORDER_BY_CODE_RECEIVED = "ORDER_BY_CODE_RECEIVED";
export const ORDER_BY_CODE_REQUEST_FAILED = "ORDER_BY_CODE_REQUEST_FAILED";

export const requestOrdersMe = (orderState, pageNumber = 1, pageSize = ORDERS_PAGE_SIZE) => ({
  type: ORDERS_ME_REQUESTED,
  orderState,
  pageNumber,
  pageSize
});
export const receiveOrdersMe = (orderState, pageSize, pageNumber, total, items) => ({
  type: ORDERS_ME_RECEIVED,
  orderState,
  pageSize,
  pageNumber,
  total,
  items
});

export const requestOrderByCode = orderCode => ({ type: ORDER_BY_CODE_REQUESTED, id: orderCode });
export const receiveOrder = order => ({ type: ORDER_BY_CODE_RECEIVED, payload: order, id: order.code });
